import {
  Box,
  Button,
  Container,
  FormControl,
  FormLabel,
  Grid,
  Link,
  TextField,
  Typography,
} from '@mui/material'
import { theme } from 'config'
import { inject, observer } from 'mobx-react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { AuthStore, RoutingStore } from 'stores'
import { FixedLogo } from 'components'

export interface IForgotPasswordProps {
  authStore?:    AuthStore,
  routingStore?: RoutingStore,
}

export const ForgotPassword = inject('authStore', 'routingStore')(observer((props: IForgotPasswordProps) => {
  const { t } = useTranslation();
  const { routingStore, authStore } = props;

  const [email,        setEmail]        = React.useState<string>('');
  const [instructions, setInstructions] = React.useState<string>('');

  const handleSubmit = async () => {
    try {
      const res = await authStore.requestForgotPassword(email);
      setEmail('');
      setInstructions(res);
    } catch(err) {
      console.error("Failed to handle reset password request", err);
    }
  }

  const getResponseTextTranslation = (instructions: string) => {
    switch (instructions) {
      case 'success':
        return t('reset_password_instructions_sent_check_your_email_inbox')
      default:
        return t('reset_password_error')
    }
  }

  return (
    <Container maxWidth='sm'>
      <FixedLogo />
      <Grid
        container
        direction      = 'column'
        alignItems     = 'center'
        justifyContent = 'center'
        width          = '100%'
        sx             = {{ minHeight: '100vh', height:'100%' }}
      >
        <Grid item xs={12}>
          <Typography variant='h2' textAlign='center'>
            {t('forgot_password')}
          </Typography>
          <FormControl fullWidth margin='normal'>
            <FormLabel>{t('email')}</FormLabel>
            <TextField
              hiddenLabel
              type     = 'text'
              name     = {'email'}
              value    = {email}
              id       = 'outlined'
              variant  = 'outlined'
              onChange = {(e) => setEmail(e.target.value)}
            />
            {instructions.length > 0 && (
              <Typography
                textAlign = 'center'
                color     = {
                  instructions === 'success'
                    ? theme.palette.green.main
                    : theme.palette.error.main
                }
              >
                {getResponseTextTranslation(instructions)}
              </Typography>
            )}
          </FormControl>
          <Box
            display       = 'flex'
            flexDirection = 'column'
            alignItems    = 'center'
            gap           = {3}
            mt            = {3}
          >
            <Button
              variant  = 'contained'
              disabled = {!email}
              onClick  = {handleSubmit}
            >
              {t('reset_password')}
            </Button>
            <Link
              color   = 'secondary'
              onClick = {() => routingStore.push(RoutingStore.loginPage)}
            >
              {t('back')}
            </Link>
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
}));
